var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography,
    borders = _ref.borders,
    breakpoints = _ref.breakpoints;
  return {
    quizEntryShowPadding: "".concat(spacing.large, " ").concat(spacing.small),
    quizEntryShowBackgroundColor: colors.contrasts.white1010,
    headerHeight: '2rem',
    headerRightPadding: spacing.xSmall,
    dndBorder: "".concat(borders.style, " ").concat(borders.widthSmall, " ").concat(colors.contrasts.blue4570),
    rightHeaderZIndex: '3333',
    rightHeaderColor: colors.contrasts.grey100100,
    titleInteractionTypeNamePointsColor: colors.contrasts.grey4570,
    titleInteractionTypeNamePointsFontSize: typography.fontSizeSmall,
    titleInteractionTypeNamePointsLeftMargin: spacing.xSmall,
    titleInteractionTypeNamePointsRightMargin: spacing.xSmall,
    itemHolderMargin: spacing.xSmall,
    optionsButtonDragDropHandleFontSize: typography.fontSizeMedium,
    optionsButtonDragDropHandleMargin: spacing.xSmall,
    phoneConnectingLinesBorderWidth: borders.widthSmall,
    phoneConnectingLinesBorderColor: colors.contrasts.grey4570,
    phoneBreakPoint: "max-width: ".concat(breakpoints.medium)
  };
};
export default generateComponentTheme;